export const WritesonicActionTypes = {
  API_RESPONSE_SUCCESS: '@@writesonic/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@writesonic/API_RESPONSE_ERROR',

  GET_IDEAS: '@@writesonic/GET_IDEAS',
  GET_INTRO: '@@writesonic/GET_INTRO',
  GET_OUTLINES: '@@writesonic/GET_OUTLINES',
  WRITE_ARTICLE: '@@writesonic/WRITE_ARTICLE',
  EXPAND_TEXT: '@@writesonic/EXPAND_TEXT',
  INSTANT_WRITER: '@@writesonic/INSTANT_WRITER',
  WRITE_PARAGRAPH: '@@writesonic/WRITE_PARAGRAPH',
  GENERATE_IMAGE: '@@writesonic/GENERATE_IMAGE',

  RESET: '@@writesonic/RESET'
}
